export const VALIDATE_NEW_RUN_PARAMS = 'action/VALIDATE_NEW_RUN_PARAMS';
export const RESET_VALIDATION_RESULT = 'action/RESET_VALIDATION_RESULT';

export default {
  VALIDATE_NEW_RUN_PARAMS,
  RESET_VALIDATION_RESULT
};
